module.exports = __webpack_public_path__ + "static/olasode-495b359e391d3c7322beea259f5dadbc.jpg";